import React from 'react'
import { analytics } from 'Modules/Analytics'
import { initiatives } from 'Modules/Analytics/trackActionInterface/Impact/Initiatives'
import { useAppState } from 'Context/AppContext/AppContext'
import { TextField } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import {
  Check as CheckIcon,
  CloseOutlined as CloseIcon,
} from '@mui/icons-material'
import { Moment } from 'moment/moment'
import { colors } from '@resiliatech/birdsong'
import { ChartDataPointInput } from 'Generated/graphql-types'
import {
  ChartDateCell,
  ChartTableCell,
  ChartTableRow,
  RowActions,
} from './EditChartDataTable.styled'
import { DatePicker } from '../../../../SharedComponents/DatePicker/DatePicker'

type CreateNewEntryRowProps = {
  newEntryDate: Moment | null
  newEntryValues: Record<number, ChartDataPointInput>
  onChangeDate: (date: Moment | null) => void
  onCreateDataPoints: () => void
  onChangeValues: (newValue: string, point: any) => void
  onClose: () => void
  goalId: string
}

export const CreateNewEntryRow = ({
  newEntryDate,
  newEntryValues,
  onChangeDate,
  onCreateDataPoints,
  onChangeValues,
  onClose,
  goalId,
}: CreateNewEntryRowProps) => {
  const {
    nonprofitOrgConfig: { role, nonprofitOrgRole },
  } = useAppState()
  const handleCancelDataPoint = () => {
    analytics.trackActionCreator(initiatives.Create_Data_Point_Abandoned)({
      role,
      relationship: nonprofitOrgRole,
      goalId,
    })
    onClose()
  }

  const newEntryRow = Object.values(newEntryValues).map((point) => (
    <ChartTableCell key={`${point.chartCategoryId}`} align='right'>
      <TextField
        id='createChartDataRow'
        variant='outlined'
        size='small'
        defaultValue={point.value ?? ''}
        onChange={({ target }) => {
          onChangeValues(target.value, point)
        }}
        required
        sx={{ width: '100%' }}
        type='number'
      />
    </ChartTableCell>
  ))

  return (
    <ChartTableRow>
      <ChartDateCell align='left'>
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale='en-us'>
          <DatePicker
            date={newEntryDate?.toISOString()}
            onDateSelected={(newDate): void => {
              onChangeDate(newDate)
            }}
            styles={{ width: '100%' }}
          />
        </LocalizationProvider>
      </ChartDateCell>
      {newEntryRow}
      <ChartTableCell align='left'>
        <RowActions>
          <CheckIcon
            cursor='pointer'
            sx={{ color: colors.interactive.primaryEnabled }}
            onClick={onCreateDataPoints}
          />
          <CloseIcon
            cursor='pointer'
            sx={{ color: colors.interactive.primaryEnabled }}
            onClick={handleCancelDataPoint}
          />
        </RowActions>
      </ChartTableCell>
    </ChartTableRow>
  )
}
